"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.KeyDoesNotExist = new Error("Key does not exist. Make sure you properly instantiated the keystore.");
exports.NotKeyPair = new Error("Retrieved a symmetric key when an asymmetric keypair was expected. Please use a different key name.");
exports.NotKey = new Error("Retrieved an asymmetric keypair when an symmetric key was expected. Please use a different key name.");
exports.ECCNotEnabled = new Error("ECC is not enabled for this browser. Please use RSA instead.");
exports.UnsupportedCrypto = new Error("Cryptosystem not supported. Please use ECC or RSA");
exports.InvalidKeyUse = new Error("Invalid key use. Please use 'read' or 'write");
function checkIsKeyPair(keypair) {
    if (!keypair || keypair === null) {
        throw exports.KeyDoesNotExist;
    }
    else if (keypair.privateKey === undefined) {
        throw exports.NotKeyPair;
    }
    return keypair;
}
exports.checkIsKeyPair = checkIsKeyPair;
function checkIsKey(key) {
    if (!key || key === null) {
        throw exports.KeyDoesNotExist;
    }
    else if (key.privateKey !== undefined || key.algorithm === undefined) {
        throw exports.NotKey;
    }
    return key;
}
exports.checkIsKey = checkIsKey;
function checkValidCryptoSystem(type) {
    checkValid(type, [types_1.CryptoSystem.ECC, types_1.CryptoSystem.RSA], exports.UnsupportedCrypto);
}
exports.checkValidCryptoSystem = checkValidCryptoSystem;
function checkValidKeyUse(use) {
    checkValid(use, [types_1.KeyUse.Read, types_1.KeyUse.Write], exports.InvalidKeyUse);
}
exports.checkValidKeyUse = checkValidKeyUse;
function checkValid(toCheck, opts, error) {
    var match = opts.some(function (opt) { return opt === toCheck; });
    if (!match) {
        throw error;
    }
}
exports.default = {
    KeyDoesNotExist: exports.KeyDoesNotExist,
    NotKeyPair: exports.NotKeyPair,
    NotKey: exports.NotKey,
    ECCNotEnabled: exports.ECCNotEnabled,
    UnsupportedCrypto: exports.UnsupportedCrypto,
    InvalidKeyUse: exports.InvalidKeyUse,
    checkIsKeyPair: checkIsKeyPair,
    checkIsKey: checkIsKey,
    checkValidCryptoSystem: checkValidCryptoSystem,
    checkValidKeyUse: checkValidKeyUse,
};
//# sourceMappingURL=errors.js.map